module.exports = __webpack_public_path__ + "static/media/portfolio.9ba81748.png";